import '@nike/eds/dist/index.css'
import { toRelativeUrl } from '@okta/okta-auth-js'
import { Security, LoginCallback } from '@okta/okta-react'
import React, { useCallback } from 'react'
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom'
import { oktaAuth } from './config/OktaConfig'
import { LoginError } from './login-error/LoginError'
import { RequiredAuth } from './shared/AuthenticatedRoute'
import '@nike/eds/dist/index.css'
import { InventoryOverview } from './pages/InventoryOverview'
import { Trigger } from './pages/Trigger'
import { Simulation } from './pages/Simulation'
import { createBrowserHistory } from 'history'
import useRoleManagement from './shared/useRoleManagement'
import TrackUserId from './shared/analytics/identify'
import { FlowOverview } from './pages/FlowOverview'
import { EntryContextOverview } from './pages/EntryContextOverview'
import { ImbalanceManagement } from './pages/ImbalanceManagement'
import { getPermissions } from './UserAccessManagement/userRolesAccessManagement'
import { UserPermissions } from './UserAccessManagement/UserRoles'

const history = createBrowserHistory()

const AppInSecureContext = () => {
    const roles = useRoleManagement()
    const userPermissions: UserPermissions = getPermissions(roles.roles)

    return (
        <>
            <TrackUserId />
            <Routes>
                <Route element={<RequiredAuth />}>
                    <Route path="/dashboard/*" element={<InventoryOverview history={history} key="dashboard" userPermissions={userPermissions} />} />
                    {userPermissions.canSimulateEvents && <Route path="/simulation/*" element={<Simulation history={history} userPermissions={userPermissions} />} />}
                    {userPermissions.canViewBasicView && <Route path="/flow-overview/*" element={<FlowOverview history={history} userPermissions={userPermissions} />} />}
                    {userPermissions.canViewBasicView && <Route path="/inventory-overview/*" element={<InventoryOverview history={history} key="inventory-overview" userPermissions={userPermissions} />} />}
                    {(userPermissions.canTriggerUKDivert || userPermissions.canTriggerBondedReturn || userPermissions.canTriggerDSLeftCW || userPermissions.canTriggerManualClearing) && <Route path="/trigger/*" element={<Trigger history={history} userPermissions={userPermissions} />} />}
                    {userPermissions.canViewEntryContext && <Route path="/entry-context-overview/*" element={<EntryContextOverview history={history} userPermissions={userPermissions} />} />}
                    {userPermissions.canViewBasicView && <Route path="/imbalance-management/*" element={<ImbalanceManagement history={history} userPermissions={userPermissions} />} />}
                    <Route path="/" element={<Navigate to="/dashboard" />} />
                    <Route path="/*"/>
                </Route>
                <Route path="/implicit/callback" element={<LoginCallback errorComponent={LoginError} />} />
            </Routes>
        </>
    )
}

const App = () => {
    const navigate = useNavigate()
    const restoreOriginalUri = useCallback(
        (_oktaAuth: any, originalUri: string) => {
            navigate(toRelativeUrl(originalUri || '/', window.location.origin), { replace: true })
        },
        [navigate]
    )

    return (
        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
            <React.Fragment>
                <AppInSecureContext />
            </React.Fragment>
        </Security>
    )
}

export default App
